import axiosInstance from '@/core/api'
import {
	GetBlacklistRequest,
	GetBlacklistResponse,
	CreateBlacklistReportRequest,
	CreateBlacklistReportResponse,
	UpdateBlacklistReportRequest,
	UpdateBlacklistReportResponse,
} from '../../type'

export const getBlacklist = async (
	payload: GetBlacklistRequest,
): Promise<GetBlacklistResponse> => {
	const response = await axiosInstance.get<GetBlacklistResponse>(
		'/admin/blacklist',
		{
			params: payload,
		},
	)
	return response.data
}

export const createBlacklistReport = async (
	payload: CreateBlacklistReportRequest,
): Promise<CreateBlacklistReportResponse> => {
	const response = await axiosInstance.post<CreateBlacklistReportResponse>(
		'/admin/blacklist/report',
		payload,
	)
	return response.data
}

export const updateBlacklistReport = async (
	id: string,
	payload: UpdateBlacklistReportRequest,
): Promise<UpdateBlacklistReportResponse> => {
	const response = await axiosInstance.patch<UpdateBlacklistReportResponse>(
		`/admin/blacklist/report/${id}`,
		payload,
	)
	return response.data
}

export const deleteBlacklistReport = async (id: string): Promise<void> => {
	await axiosInstance.delete(`/admin/blacklist/report/${id}`)
}
